import { ProfileLiteView } from "admin/src/server/mappers/profile/profile";
import { defaultEmailFromProfile } from "admin/src/utils/helpers/profile/defaultEmailFromProfile";

import { FunctionFactory } from "survey-core";

export const registerEmailSpeakerStringExpression = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const emailSpeakerStringExpression = function (this: never, params: any[]) {
    const stringifyProfileView = params[0];
    const symposiaTitle = params[1];
    const symposiaRole = params[2];

    const address = defaultEmailFromProfile(
      JSON.stringify(stringifyProfileView) as unknown as ProfileLiteView,
    );
    return `mailto:${address}?subject=${symposiaTitle} - ${symposiaRole}`;
  };

  FunctionFactory.Instance.register(
    "email_speaker_string",
    emailSpeakerStringExpression,
  );
};
